import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading6XL,
} from "../../../typography";

import { CAREERS_URL } from "../../navigation/config/navConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";
import { cn } from "@verse_core/shared_components/ClassName";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

interface FooterHeaderProps {
  title?: string;
  titleAccent?: string;
  description?: string;
  hasJobOpeningsButton?: boolean;
  buttonText?: string;
  buttonClassName?: string;
}

export const FooterHeader = ({
  title,
  titleAccent,
  description,
  hasJobOpeningsButton,
  buttonText,
  buttonClassName,
}: FooterHeaderProps) => {
  if (!title) return null;

  return (
    <div className="tw-z-2 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-[1.5em] tw-py-[5em]">
      <div className="tw-z-20 tw-flex tw-flex-col tw-gap-y-[.5em]">
        <Heading6XL className="tw-my-0 tw-hidden tw-text-white min1040:tw-block">
          {title} <span className="tw-text-blue-2">{titleAccent}</span>
        </Heading6XL>
        <Heading2XL className="tw-my-0 tw-text-white min1040:tw-hidden">
          {title} <span className="tw-text-blue-2">{titleAccent}</span>
        </Heading2XL>

        <BodyXL className="tw-my-0 tw-text-white min1040:tw-hidden">
          {description}
        </BodyXL>
        <BodyLG className="tw-my-0 tw-hidden tw-text-white min1040:tw-block">
          {description}
        </BodyLG>
      </div>
      <div className="tw-z-20">
        {hasJobOpeningsButton ? (
          <a
            href={CAREERS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="tw-no-underline"
          >
            <StandardButton
              onClick={() => {}}
              style={"primary-blue"}
              className={cn(
                "tw-flex tw-w-[15em] tw-items-center tw-justify-center tw-gap-x-[.5em] tw-rounded-full tw-px-[2em] tw-py-[1.25em] tw-text-[16px] min440:tw-mt-[1em]",
                buttonClassName,
              )}
            >
              <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
                View job openings
              </BodyLGB>
              <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
                View job openings
              </BodyMDB>
              <FontAwesomeIcon
                icon={faUpRightFromSquare}
                className="tw-h-[1em] tw-w-[1em]"
              />
            </StandardButton>
          </a>
        ) : (
          <Link to="/contact" className="tw-no-underline">
            <StandardButton
              onClick={() => {}}
              style="primary-blue"
              className={cn(
                "tw-w-[13.75em] tw-rounded-full tw-px-[2em] tw-py-[1.25em] tw-text-[16px]",
                buttonClassName,
              )}
            >
              <BodyLGB className="tw-my-0 tw-hidden tw-text-white min1040:tw-block">
                {buttonText ? buttonText : "Get a Demo"}
              </BodyLGB>
              <BodyMDB className="tw-my-0 tw-text-white min1040:tw-hidden">
                {buttonText ? buttonText : "Get a Demo"}
              </BodyMDB>
            </StandardButton>
          </Link>
        )}
      </div>
    </div>
  );
};
